import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LandingPage as LandingPageComponent } from '../components/landing/LandingPage';
import AuthModal from '../components/auth/AuthModal';

export const LandingPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [authModalOpen, setAuthModalOpen] = useState(false);

  // Debug auth state (remove in production)
  console.log('📱 LANDING: Auth state:', { isAuthenticated });
  const [authModalMode, setAuthModalMode] = useState('login'); // 'login' or 'signup'

  const handleLogin = () => {
    setAuthModalMode('login');
    setAuthModalOpen(true);
  };

  const handleSignup = () => {
    setAuthModalMode('signup');
    setAuthModalOpen(true);
  };

  const handleExplore = () => {
    // Since we're not using routing, authenticated users will automatically see the main app
    // This function is mainly for triggering authentication state change
    if (!isAuthenticated) {
      handleSignup(); // Prompt signup first
    }
  };

  const handleNavigateToDashboard = () => {
    // Since we're not using routing, authenticated users will automatically see the main app
    // This function is mainly for triggering authentication state change
    if (!isAuthenticated) {
      handleLogin(); // Prompt login first  
    }
  };

  const handleAuthSuccess = () => {
    console.log('📱 LANDING: Authentication successful');
    setAuthModalOpen(false);

    // Check if user was trying to subscribe before logging in
    const pendingSubscription = localStorage.getItem('pendingSubscription');
    if (pendingSubscription) {
      console.log('📱 LANDING: Found pending subscription, redirecting to pricing...');
      // Add a small delay to ensure auth state is fully updated
      setTimeout(() => {
        window.location.href = '/pricing';
      }, 100);
      return;
    }
    // After successful auth, the main App component will automatically
    // show the map interface instead of the landing page
  };

  return (
    <>
      <LandingPageComponent
        onLogin={handleLogin}
        onSignup={handleSignup}
        onExplore={handleExplore}
        onNavigateToDashboard={handleNavigateToDashboard}
      />
      
      <AuthModal
        isOpen={authModalOpen}
        onClose={() => setAuthModalOpen(false)}
        defaultMode={authModalMode}
        onAuthSuccess={handleAuthSuccess}
      />
    </>
  );
};

export default LandingPage;